import ShuttleHead from './ShuttleHead'
import { lazy, Suspense } from 'react'

const ShuttleNetzero = lazy(() => import('./ShuttleNetzero').then(module => ({ default: module.ShuttleNetzero })));
const ShuttleReport = lazy(() => import('./ShuttleReport').then(module => ({ default: module.ShuttleReport })));
const ShuttleExplore = lazy(() => import('./ShuttleExplore').then(module => ({ default: module.ShuttleExplore })));
const ShuttleBooking = lazy(() => import('./ShuttleBooking'));
const ShuttleServices = lazy(() => import('./ShuttleServices'));
const StartBooking = lazy(() => import('./StartBooking'));
const ShuttleAppreciation = lazy(() => import('./ShuttleAppreciation'));
const ShuttleItNeed = lazy(() => import('./ShuttleItNeed'));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));
const shuttleFeatureId = "shuttle-software";
export default function ShuttleSoftware() {

  return (
    <>
      <ShuttleHead featureId={shuttleFeatureId}/>
      <Suspense fallback={null}>
        <ShuttleNetzero />
        <ShuttleReport />
        <ShuttleExplore />
        <ShuttleBooking />
        <StartBooking />
        <ShuttleServices />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <ShuttleItNeed
          featureId={shuttleFeatureId}
        />
      </Suspense>
    </>
  )
}
